<template>
	<span>
		<span
			v-if="source === 'DSN'"
			class="icon has-tooltip-right"
			v-tooltip.right="$t('tooltip.source.dsn')"
		>
			<span class="fas fa-folder"></span>
		</span>

		<span
			v-else-if="source === 'PAY_SLIP'"
			class="icon has-tooltip-right"
			v-tooltip.right="$t('tooltip.source.paySlip')"
		>
			<span class="fas fa-file-invoice"></span>
		</span>

		<span
			v-else-if="source === 'USER'"
			class="icon has-tooltip-right"
			v-tooltip.right="$t('tooltip.source.user')"
		>
			<span class="fas fa-user-tie"></span>
		</span>

		<span
			v-else-if="source === 'MAPPING'"
			class="icon has-tooltip-right"
			v-tooltip.right="$t('tooltip.source.mapping')"
		>
			<span class="fas fa-draw-polygon"></span>
		</span>
	</span>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { EmployeeDetailsValueRepresentation } from "@/lib/apis/replicable/models";

@Component
export default class DetailsValueSourceController extends Vue {
	@Prop()
	public readonly source!: EmployeeDetailsValueRepresentation["source"];
}
</script>

<i18n src="../../i18n/Details.json"></i18n>
